<template>
    <section class="detail-section _preview-section">
        <div class="section-inner">
            <h2 class="heading-section"><span>Detail</span></h2>

            <div class="detail-item-wrap">

                <div class="detail-item edit-checkbox">
                    <ul class="list_common">

                        <!--価値軸（Price zone）-->
                        <WorthPreview v-if="$store.state.detail.set.brand.price_zone && !showShowroom"/>

                        <!--カテゴリ-->
                        <CategoryPreview />

                        <!--プライス-->
                        <PricePreview v-if="showBrand || showShowroom"/>

                        <!--ターゲット-->
                        <TargetPreview />

                        <!--オーダー-->
                        <OrderPreview v-if="(showBrand && personalAndBasic) ||
                                            (showBrand && unitAndBasic) ||
                                            (showBrand && adminAndBasic) ||
                                            (pageTypeStep10 == 1 && activeBasicBrand)"/>

                    </ul>
                </div>

                <div class="detail-item">
                    <ul class="list_common">

                        <!--オンライン/WEB-->
                        <OnlinePreview />

                        <!--お支払い方法-->
                        <PaymentMethodPreview v-if="(showBrand && personalAndBasic) ||
                                                    (showBrand && unitAndBasic) ||
                                                    (showBrand && adminAndBasic) ||
                                                    (pageTypeStep10 == 1 && activeBasicBrand)"/>

                        <!--対象店舗-->
                        <NetPreview />

                        <!--拠点-->
                        <BasePreview v-if="showBrand || showShowroom"/>

                        <!--所在地-->
                        <AddressPreview v-if="showShop"/>

                        <!--取り扱いブランド-->
                        <HandlingBrandPreview v-if="showShop"/>

                    </ul>
                </div>

            </div><!--/.detail-item-wrap-->

        </div><!--/.section-inner-->

    </section>
</template>

<script>
    import RatePreview from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/06DetailParts/01RatePreview'
    import SalesPreview from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/06DetailParts/02SalesPreview'
    import WorthPreview from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/06DetailParts/03WorthPreview'
    import CategoryPreview from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/06DetailParts/04CategoryPreview'
    import PricePreview from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/06DetailParts/05PricePreview'
    import TargetPreview from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/06DetailParts/06TargetPreview'
    import SalesStylePreview from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/06DetailParts/07SalesStylePreview'
    import OrderPreview from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/06DetailParts/08OrderPreview'
    import OnlinePreview from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/06DetailParts/09OnlinePreview'
    import PaymentMethodPreview from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/06DetailParts/10PaymentMethodPreview'
    import NetPreview from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/06DetailParts/11NetPreview'
    import BasePreview from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/06DetailParts/12BasePreview'
    import AddressPreview from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/06DetailParts/13AddressPreview'
    import HandlingBrandPreview from '@/components/EndUser/MembershipRegistrationShopStep/Step10Parts/06DetailParts/14HandlingBrandPreview'

    export default {
        components: {
            RatePreview,
            SalesPreview,
            WorthPreview,
            CategoryPreview,
            PricePreview,
            TargetPreview,
            SalesStylePreview,
            OrderPreview,
            OnlinePreview,
            PaymentMethodPreview,
            NetPreview,
            BasePreview,
            AddressPreview,
            HandlingBrandPreview,
        },
        computed: {
            showBrand() {
                var url = location.pathname;
                return url.indexOf( '/brand' ) != -1;
            },
            showShop() {
                var url = location.pathname;
                return url.indexOf( '/shop' ) != -1;
            },
            showShowroom() {
                var url = location.pathname;
                return url.indexOf( '/showroom' ) != -1;
            },
            personalAndBasic() {
                if (this.$store.state.detail.set.personalAndBasic) {
                    return true;
                }
            },
            unitAndBasic() {
                if (this.$store.state.detail.set.unitAndBasic) {
                    return true;
                }
            },
            adminAndBasic() {
                if (this.$store.state.detail.set.adminAndBasic) {
                    return true;
                }
            },
            pageTypeStep10() {
                var url = location.pathname;
                if (url.indexOf( 'registration' ) != -1) {
                    //初回編集
                    return 0;
                } else if (url.indexOf( '/detail' ) != -1) {
                    if (this.$store.state.detail.set.brand.id) {
                        //管理画面での編集
                        return 1;
                    } else {
                        //管理画面での新規追加
                        return 3;
                    }
                } else {
                    //エンドユーザー側での表示
                    return 2;
                }
            },
            activeBasicBrand() {
                if (this.$store.state.detail.set.activeBasicBrand) {
                    return true;
                }
            },
        }
    }
</script>

